export default class Cenik {

    public id: number;
    public name: string;
    public value: number;
    public price: number;
    public valid: boolean;

    public clone(): Cenik {
        const newDen: Cenik = new Cenik();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): Cenik {
        this.id = json.id;
        this.name = json.name;
        this.value = json.value;
        this.price = json.price;
        this.valid = json.valid;
        return this;
    }

    public loadFromEntity(ent: Cenik): Cenik {
        this.id = ent.id;
        this.name = ent.name;
        this.value = ent.value;
        this.price = ent.price;
        this.valid = ent.valid;
        return this;
    }

}


// WEBPACK FOOTER //
// ./src/models/Cenik.tsx